module.exports = __webpack_public_path__ + "static/media/gin.089fcf54.jpg";